import TermsDialog from './TermsDialog';
export default TermsDialog;
